/* eslint-disable import/no-unresolved */
/* eslint-disable import/imports-first */
/* eslint-disable import/order */
import React, { useRef } from 'react';

import Layout from '../components/Layout';
import PartialsHeader from '../components/Partials/PartialsHeader';
import CareersOffers from '../components/Careers/CareersOffers';
import CareersOpinionBlock from '../components/Careers/CareersOpinionBlock';
import Images from '../components/imagesLandingPages';
import SectionBoxes from '../components/Careers/CareersBoxes';
import Heading from '../components/SoftwareServices/ServicesHeading';
import CareersBoard from '../components/Careers/CareersBoard';
import Knowledge from '../components/Home/HomeKnowledge';
import PartialQuestion from '../components/Partials/PartialsQuestion';
import CareersTeam from '../components/Careers/CareersTeam';
import CareersAboutUs from '../components/Careers/CareersAboutUs';

import pythonSVG from 'assets/resources/icon/python_icon.svg';
import logoJS from 'assets/resources/icon/logo_js.svg';
import blockchainSVG from 'assets/resources/pages/software-services/blockchain_icon.svg';
import djangoSVG from 'assets/resources/icon/django-11.svg';
import seoImage from '../../assets/resources/optimized-images/career-seo-img.png';

const staticContent = {
  title: 'Joining us also means',
  description:
    'In addition to a warm welcome from the whole team, you will also get these perks.',
  singleBox: [
    {
      src: Images.outcomeSVG,
      title: 'Flexible hours',
      subtitle: 'For the perfect work/life balance that fits you.'
    },
    {
      src: Images.outcomeSVG,
      title: 'Hardware',
      subtitle: 'That is at the TOP of its class.'
    },
    {
      src: Images.outcomeSVG,
      title: 'Learning and development',
      subtitle:
        'Internal and external conferences, meetups and courses for your professional development.'
    },
    {
      src: Images.outcomeSVG,
      title: 'Private health care package',
      subtitle: `Your well-being is important, so we co-finance your medical plan`
    },
    {
      src: Images.outcomeSVG,
      title: 'Remote work possibility',
      subtitle:
        'You can work remotely, from our office, or in a hybrid model! We are flexible'
    },
    {
      src: Images.outcomeSVG,
      title: 'Fun',
      subtitle: 'We have a budget for going out and getting to know each other.'
    }
  ]
};

const Careers = () => {

  const scrollToDiv = ref => ref.current.scrollIntoView({ behavior: 'smooth' });
  const markerElement = useRef();
  const careersBlockElement = useRef();

  return (
    <Layout
      title="Careers | Ulam Labs"
      description="People are important for us! Check our open job offers. Join our team of Python and blockchain developers."
      seoImage={seoImage}
    >
      <PartialsHeader>
        <div className="container">
          <div className="content">
            <div className="body">
              <h1 className="title">Careers</h1>
            </div>
          </div>
        </div>
      </PartialsHeader>
      <div className="careers text-format">
        <Heading
          reference={markerElement}
          click={() => scrollToDiv(careersBlockElement)}
          additionalConfig={{
            type: 'careers',
            btnText: 'See open positions'
          }}
          headingText={{
            title: 'Grow your career with us',
            description:
              'Join a fast-paced company building products and services that have a meaningful impact on the world. Get to know us, join our journey to build a better world with technology.',
            img: [pythonSVG, logoJS, blockchainSVG, djangoSVG]
          }}
        />
        <CareersAboutUs
          careers
          content={{
            title: 'Why us?',
            subtitle: `We are a team passionate about technology and innovation. Our culture stands on the pillars of respect and discipline. They shape the way we work with clients and with each other.`,
            list: [
              {
                subtitle:
                  'We support our team through continuous learning & autonomy.'
              },
              {
                subtitle: 'Passion makes us powerful.'
              },
              {
                subtitle: 'We create value and positive impact with technology.'
              }
            ]
          }}
        />
        <SectionBoxes
          reference={markerElement}
          click={() => scrollToDiv(careersBlockElement)}
          staticContent={staticContent}
        />
        <CareersOpinionBlock />
        <CareersOffers reference={careersBlockElement} />
        <CareersBoard />
        <div className="d-none d-lg-block">
          <CareersTeam />
        </div>
        <Knowledge
          useSpecificPostsByTag={['Company']}
          customTitle="More about us"
          versionPillar
        />
        <PartialQuestion
          title="Haven’t found an offer that suits your skills?"
          subtitle="Contact us and give us a pitch! We are always open to meet savvy people!"
        />
      </div>
    </Layout>
  );
};

export default Careers;
